module.exports = __webpack_public_path__ + "static/media/TRIAL-1-if-wrong.302d2a5d.mp3";